export const geosConstants = {
    GETGEO_SUCCES: 'GET_GEO_SUCCES',
    UPDATEGEO_SUCCES: 'UPDATE_GEO_SUCCES'
};
